import { render, staticRenderFns } from "./myRobotUserDialog.vue?vue&type=template&id=52b332c0&"
import script from "./myRobotUserDialog.vue?vue&type=script&lang=js&"
export * from "./myRobotUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./myRobotUserDialog.vue?vue&type=style&index=0&id=52b332c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports